module.exports = __webpack_public_path__ + "img/682.c14b7cc2.png";